import { Injectable } from '@angular/core';
import { AppConsts } from 'shared/AppConsts';
import { environment } from 'environments/environment';


@Injectable()
export class ApptokenService {

  constructor() {
  }

  setToken = function (authToken: string, expireDate?: Date): void {     
      var cookieValue = encodeURIComponent('Abp.AuthToken') + '=';

      if (authToken) {
        cookieValue = cookieValue + encodeURIComponent(authToken);
      }

      if (expireDate) {
        cookieValue = cookieValue + "; expires=" + expireDate.toUTCString();
      }
      cookieValue = cookieValue + "; path=/";
      
      document.cookie = cookieValue;
  };

  clearToken = function():void{
    this.setToken();
  }

}



// WEBPACK FOOTER //
// ./src/shared/utils/apptoken.service.ts